import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { ConfirmationService, MessageService } from "primeng/api";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ToastModule } from "primeng/toast";

@Component({
  selector: "app-root",
  imports: [RouterOutlet, ConfirmDialogModule, ToastModule],
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  providers: [ConfirmationService, MessageService],
})
export class AppComponent {
  title = "ARC-CONSULTING";

  constructor(private confirmationService: ConfirmationService) {}
}
